export const PayTypeIds = {
    ITEM_ID: '18eb51c4-8486-a7f3-4de0-14477870e205',
    MONEY_ID: '67828177-f82e-698c-74f7-18386555d6bc',
    VOUCHER_ID: '1e705c62-548c-818a-e2c3-ca66d8b7fb2b',
};
//# sourceMappingURL=statements-pay-types.dto.js.map